import * as React from 'react';
import { useSelector } from 'react-redux';

export default function useWindowSize() {
  const isMobile = useSelector(({ helper }) => helper.isMobile);
  const [windowSize, setWindowSize] = React.useState({
    width: 0,
    height: 0,
    isMobile
  });

  React.useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth < 767,
        isTablet: window.innerWidth < 1135
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
